import AuditLogsPage from 'src/pages/AuditLogs';
import TasksPage from 'src/pages/Tasks';
import Integration from 'src/pages/Integration';

import Applications from '../pages/Applications';
import ApplicationNew from '../pages/Applications/New';
import ApplicationsCreateFromRequest from '../pages/Applications/CreateFromRequest';
import Home from '../pages/Home';
import Integrations from '../pages/Integrations/Integrations.tsx';
import IntegrationAuth from '../pages/Integrations/IntegrationAuth.tsx';
import Migrations from '../pages/Migrations';
import Impersonate from '../pages/Impersonate/Impersonate.tsx';

import type { RouteObject } from 'react-router';

export const mainRoutes: RouteObject = {
  children: [
    {
      index: true,
      path: '/',
      element: <Home />,
    },
    {
      path: 'applications',
      element: <Applications />,
    },
    {
      path: 'applications/new',
      element: <ApplicationNew />,
    },
    {
      path: 'applications/new/app',
      element: <ApplicationsCreateFromRequest />,
    },
    {
      path: 'integrations',
      element: <Integrations />,
    },
    {
      path: 'integrations/:id',
      element: <Integration />,
    },
    {
      path: 'integrations/auth/:provider',
      element: <IntegrationAuth />,
    },
    {
      path: 'tasks',
      element: <TasksPage />,
    },
    {
      path: 'migrations',
      element: <Migrations />,
    },
    {
      path: 'activity-log',
      element: <AuditLogsPage />,
    },
    {
      path: 'impersonate/:userId',
      element: <Impersonate />,
    },
  ],
};
